import StoreInputForm from "../components/organisms/StoreInputForm";

function StoreInputPage({ date, onDateChange }) {
  return (
    <div>
      <StoreInputForm date={date} onDateChange={onDateChange} />
    </div>
  );
}

export default StoreInputPage;
